import React, { useState } from 'react';
import { RefreshCw, Search, Phone, MessageSquare, FileText, Mail, MapPin, PieChart as PieIcon, Users, Smartphone, Heart, Share2, ThumbsUp } from 'lucide-react';

export function Reports() {
  const [mainReport, setMainReport] = useState('rpm_gg');
  const [subTab, setSubTab] = useState('overview');
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');

  const monthlyReports = {
    rpm_gg: {
      name: 'Google Ads',
      title: 'JUNE 2026 Google Ads Performance Report',
      channel: 'Google Ads Search'
    },
    rpm_tt: {
      name: 'TikTok Ads',
      title: 'TikTok Ads Performance Overview Report',
      channel: 'TikTok Ads'
    },
    rpm_meta: {
      name: 'Meta Ads',
      title: 'JUNE 2026 Facebook Ads Overall Performance Report',
      channel: 'Meta Facebook Ads'
    },
    rpm_jll_fb: {
      name: 'Facebook Ads (Lead Gen)',
      title: 'Facebook Ads Lead Generation Performance Report',
      channel: 'Meta Facebook Ads'
    }
  };

  const allReportData = {
    rpm_gg: {
      title: 'Google Search Performance Overview',
      tabs: [
        { id: 'overview', label: 'Search Performance Overview' },
        { id: 'welding_machine', label: 'Search: Welding Machine' },
        { id: 'welding_rod', label: 'Search: Welding Rod' },
        { id: 'laser_welding', label: 'Search: Laser Welding Machine' },
        { id: 'pmax', label: 'P-Max' },
        { id: 'youtube_overview', label: 'YouTube Ads Performance Overview' },
        { id: 'youtube_targeting', label: 'YouTube Ads Targeting' }
      ],
      subData: {
        overview: {
          title: 'Search Performance Overview (All Campaigns | Compared to previous period)',
          kpis: [
            { label: 'Clicks', value: '1,389' },
            { label: 'Impressions', value: '20,008' },
            { label: 'CTR', value: '6.94%' },
            { label: 'Conversions', value: '81.89', isHighlight: true },
            { label: 'Conv. rate', value: '5.90%' },
            { label: 'Avg. CPC', value: '฿17.57' },
            { label: 'Cost / conv.', value: '฿297.94' },
            { label: 'Cost', value: '฿24,398.43' }
          ],
          keywords: [
            { name: 'Search: Welding Machine', clicks: '691', impressions: '9,400', ctr: '7.35%', avgCpc: '฿23.02', conv: '45.89', cpl: '฿346.61', convRate: '6.64%', cost: '฿15,905.65' },
            { name: 'Search: Welding Rod', clicks: '514', impressions: '9,010', ctr: '5.70%', avgCpc: '฿10.54', conv: '27.00', cpl: '฿200.56', convRate: '5.25%', cost: '฿5,415.22' },
            { name: 'Search: Laser Welding Machine', clicks: '184', impressions: '1,598', ctr: '11.51%', avgCpc: '฿16.73', conv: '9.00', cpl: '฿341.95', convRate: '4.89%', cost: '฿3,077.57' }
          ]
        },
        welding_machine: {
          title: 'Search: Welding Machine (Search Campaigns | Compared to previous period)',
          kpis: [
            { label: 'Clicks', value: '691' },
            { label: 'Impressions', value: '9,400' },
            { label: 'CTR', value: '7.35%' },
            { label: 'Avg. CPC', value: '฿23.02' },
            { label: 'Conversions', value: '45.89', isHighlight: true },
            { label: 'Cost / conv.', value: '฿346.61' },
            { label: 'Cost', value: '฿15,905.65' },
            { label: 'Conv. rate', value: '6.64%' }
          ],
          conversionsBreakdown: [
            { type: 'Click to LINE', count: '38.9', icon: MessageSquare, color: '#06C755' },
            { type: 'Click to Call', count: '4.99', icon: Phone, color: '#2563EB' },
            { type: 'Submit a Form', count: '2.00', icon: FileText, color: '#D97706' }
          ],
          keywords: [
            { name: 'Inverter Welding Machine', clicks: '529', impressions: '7,539', ctr: '7.02%', avgCpc: '฿22.47', conv: '28.94', cpl: '฿410.71', convRate: '5.47%', cost: '฿11,886.72' },
            { name: 'MIG Welding Machine', clicks: '101', impressions: '1,159', ctr: '8.71%', avgCpc: '฿17.59', conv: '6.95', cpl: '฿255.68', convRate: '6.88%', cost: '฿1,776.22' },
            { name: 'TIG Tungsten Welding', clicks: '31', impressions: '380', ctr: '8.16%', avgCpc: '฿49.93', conv: '8.00', cpl: '฿193.49', convRate: '25.81%', cost: '฿1,547.89' },
            { name: 'Welding Machine Supplier', clicks: '30', impressions: '322', ctr: '9.32%', avgCpc: '฿23.16', conv: '2.00', cpl: '฿347.41', convRate: '6.67%', cost: '฿694.81' }
          ]
        },
        welding_rod: {
          title: 'Search: Welding Rod (Search Campaigns | Compared to previous period)',
          kpis: [
            { label: 'Clicks', value: '514' },
            { label: 'Impressions', value: '9,010' },
            { label: 'CTR', value: '5.70%' },
            { label: 'Avg. CPC', value: '฿10.54' },
            { label: 'Conversions', value: '27.00', isHighlight: true },
            { label: 'Cost / conv.', value: '฿200.56' },
            { label: 'Cost', value: '฿5,415.22' },
            { label: 'Conv. rate', value: '5.25%' }
          ],
          conversionsBreakdown: [
            { type: 'Click to LINE', count: '26.00', icon: MessageSquare, color: '#06C755' },
            { type: 'Submit a Form', count: '1.00', icon: FileText, color: '#D97706' }
          ],
          keywords: [
            { name: 'Premium Welding Rod', clicks: '68', impressions: '542', ctr: '12.55%', avgCpc: '฿9.74', conv: '9.00', cpl: '฿73.60', convRate: '13.24%', cost: '฿662.38' },
            { name: 'Welding Rod', clicks: '140', impressions: '3,272', ctr: '4.28%', avgCpc: '฿8.92', conv: '4.00', cpl: '฿312.11', convRate: '2.86%', cost: '฿1,248.42' },
            { name: 'Tungsten Welding Rod 2.4', clicks: '21', impressions: '156', ctr: '13.46%', avgCpc: '฿13.70', conv: '3.00', cpl: '฿95.87', convRate: '14.29%', cost: '฿287.62' },
            { name: 'High Quality Welding Rod', clicks: '74', impressions: '1,311', ctr: '5.64%', avgCpc: '฿13.26', conv: '2.00', cpl: '฿490.49', convRate: '2.70%', cost: '฿980.98' },
            { name: 'Industrial Grade Welding Rod', clicks: '6', impressions: '97', ctr: '6.19%', avgCpc: '฿9.64', conv: '2.00', cpl: '฿28.93', convRate: '33.33%', cost: '฿57.86' },
            { name: 'Stainless Steel Welding Wire', clicks: '5', impressions: '78', ctr: '6.41%', avgCpc: '฿9.75', conv: '1.33', cpl: '฿36.56', convRate: '26.67%', cost: '฿48.74' },
            { name: 'Stainless Steel Welding', clicks: '38', impressions: '739', ctr: '5.14%', avgCpc: '฿9.34', conv: '1.00', cpl: '฿354.85', convRate: '2.63%', cost: '฿354.85' },
            { name: 'Industrial Welding Wire', clicks: '28', impressions: '496', ctr: '5.65%', avgCpc: '฿14.69', conv: '1.00', cpl: '฿411.31', convRate: '3.57%', cost: '฿411.31' },
            { name: 'Grade A Stainless Steel Rod', clicks: '7', impressions: '75', ctr: '9.33%', avgCpc: '฿10.86', conv: '1.00', cpl: '฿75.99', convRate: '14.29%', cost: '฿75.99' },
            { name: 'Welding Wire 0.8mm', clicks: '6', impressions: '92', ctr: '6.52%', avgCpc: '฿10.90', conv: '1.00', cpl: '฿65.39', convRate: '16.67%', cost: '฿65.39' },
            { name: 'Welding Wire Supplier', clicks: '5', impressions: '38', ctr: '13.16%', avgCpc: '฿8.81', conv: '1.00', cpl: '฿44.03', convRate: '20.00%', cost: '฿44.03' },
            { name: 'Stainless Steel Rod', clicks: '38', impressions: '696', ctr: '5.46%', avgCpc: '฿9.68', conv: '0.67', cpl: '฿551.57', convRate: '1.75%', cost: '฿367.72' }
          ]
        },
        laser_welding: {
          title: 'Search: Laser Welding Machine (Search Campaigns | Compared to previous period)',
          kpis: [
            { label: 'Clicks', value: '184' },
            { label: 'Impressions', value: '1,598' },
            { label: 'CTR', value: '11.51%' },
            { label: 'Avg. CPC', value: '฿16.73' },
            { label: 'Conversions', value: '9.00', isHighlight: true },
            { label: 'Cost / conv.', value: '฿341.95' },
            { label: 'Cost', value: '฿3,077.57' },
            { label: 'Conv. rate', value: '4.89%' }
          ],
          conversionsBreakdown: [
            { type: 'Click to Call', count: '4.00', icon: Phone, color: '#2563EB' },
            { type: 'Click to LINE', count: '4.00', icon: MessageSquare, color: '#06C755' },
            { type: 'Submit a Form', count: '1.00', icon: FileText, color: '#D97706' }
          ],
          keywords: [
            { name: 'Laser Welding Machine', clicks: '120', impressions: '1,025', ctr: '11.71%', avgCpc: '฿16.92', conv: '5.00', cpl: '฿406.00', convRate: '4.17%', cost: '฿2,030.00' },
            { name: 'Laser Welding', clicks: '11', impressions: '129', ctr: '8.53%', avgCpc: '฿15.80', conv: '3.00', cpl: '฿57.94', convRate: '27.27%', cost: '฿173.81' },
            { name: 'laser welding machine', clicks: '13', impressions: '115', ctr: '11.30%', avgCpc: '฿15.05', conv: '1.00', cpl: '฿195.60', convRate: '7.69%', cost: '฿195.60' },
            { name: 'Laser Welder Price', clicks: '22', impressions: '176', ctr: '12.50%', avgCpc: '฿13.75', conv: '0.00', cpl: '฿0.00', convRate: '0.00%', cost: '฿302.55' },
            { name: 'Laser Welding Cabinet', clicks: '16', impressions: '135', ctr: '11.85%', avgCpc: '฿22.38', conv: '0.00', cpl: '฿0.00', convRate: '0.00%', cost: '฿358.10' },
            { name: 'Steel Laser Welder', clicks: '2', impressions: '18', ctr: '11.11%', avgCpc: '฿8.75', conv: '0.00', cpl: '฿0.00', convRate: '0.00%', cost: '฿17.51' }
          ]
        },
        pmax: {
          title: 'P-Max Performance Overview',
          kpis: [
            { label: 'Clicks', value: '1,541' },
            { label: 'Impressions', value: '22,066' },
            { label: 'CTR', value: '6.98%' },
            { label: 'Conversions', value: '119.14', isHighlight: true },
            { label: 'Conv. rate', value: '2.29%' },
            { label: 'Avg. CPC', value: '฿1.97' },
            { label: 'Cost / conv.', value: '฿25.51' },
            { label: 'Cost', value: '฿3,038.70' }
          ],
          conversionsBreakdown: [
            { type: 'Click to LINE', count: '86.97', icon: MessageSquare, color: '#06C755' },
            { type: 'Click to Call', count: '20.14', icon: Phone, color: '#2563EB' },
            { type: 'Submit a Form', count: '8.00', icon: FileText, color: '#D97706' },
            { type: 'Click to Email', count: '4.02', icon: Mail, color: '#7C3AED' }
          ],
          regionsBreakdown: [
            { region: 'Bangkok Metro', clicks: 361, conversions: 38 },
            { region: 'Nakhon Ratchasima', clicks: 83, conversions: 7 },
            { region: 'Nonthaburi & Songkhla', clicks: 63, conversions: 6 },
            { region: 'Samut Prakan & Ubon', clicks: 57, conversions: 5.5 },
            { region: 'Chonburi', clicks: 49, conversions: 5 }
          ],
          keywords: [
            { name: 'P-Max Asset Group #1 — Industrial Hardware Catalog', clicks: '850', impressions: '12,400', ctr: '6.85%', avgCpc: '฿1.95', conv: '68.50', cpl: '฿24.20', convRate: '8.06%', cost: '฿1,657.50' },
            { name: 'P-Max Asset Group #2 — Welding Tools Smart Campaign', clicks: '691', impressions: '9,666', ctr: '7.15%', avgCpc: '฿2.00', conv: '50.64', cpl: '฿27.27', convRate: '7.33%', cost: '฿1,381.20' }
          ]
        },
        youtube_overview: {
          title: 'YouTube Ads Performance Overview',
          kpis: [
            { label: 'Video Views', value: '185,400' },
            { label: 'Impressions', value: '412,000' },
            { label: 'View Rate', value: '45.0%' },
            { label: 'Avg. CPV', value: '฿0.35' },
            { label: 'Clicks', value: '2,840' },
            { label: 'Conversions', value: '38.5', isHighlight: true },
            { label: 'Cost', value: '฿64,890.00' },
            { label: 'Cost / conv.', value: '฿1,685.45' }
          ],
          keywords: [
            { name: 'YouTube Video Ad #1 — Industrial Welding Testimonial', clicks: '1,420', impressions: '210,000', ctr: '0.68%', avgCpc: '฿22.80', conv: '21.00', cpl: '฿1,540.00', convRate: '1.48%', cost: '฿32,340.00' },
            { name: 'YouTube Video Ad #2 — Laser Welding Speed Demo', clicks: '1,420', impressions: '202,000', ctr: '0.70%', avgCpc: '฿22.92', conv: '17.50', cpl: '฿1,860.00', convRate: '1.23%', cost: '฿32,550.00' }
          ]
        },
        youtube_targeting: {
          title: 'YouTube Ads Audience Targeting Performance',
          kpis: [
            { label: 'Audience Reach', value: '320,000' },
            { label: 'Engagements', value: '14,200' },
            { label: 'Engagement Rate', value: '4.44%' },
            { label: 'Conversions', value: '38.5', isHighlight: true },
            { label: 'Cost', value: '฿64,890.00' },
            { label: 'Cost / conv.', value: '฿1,685.45' }
          ],
          keywords: [
            { name: 'Audience — Industrial Construction Engineers', clicks: '1,200', impressions: '160,000', ctr: '0.75%', avgCpc: '฿20.50', conv: '18.00', cpl: '฿1,366.67', convRate: '1.50%', cost: '฿24,600.00' },
            { name: 'Audience — Metal Fabrication Mechanics', clicks: '980', impressions: '140,000', ctr: '0.70%', avgCpc: '฿22.10', conv: '12.50', cpl: '฿1,732.64', convRate: '1.28%', cost: '฿21,658.00' },
            { name: 'Audience — Hardware Store Retail Owners', clicks: '660', impressions: '112,000', ctr: '0.59%', avgCpc: '฿28.23', conv: '8.00', cpl: '฿2,329.00', convRate: '1.21%', cost: '฿18,632.00' }
          ]
        }
      }
    },
    rpm_tt: {
      title: 'TikTok Ads Performance Overview Report',
      kpis: [
        { label: 'Impressions', value: '192.1K' },
        { label: 'Reach', value: '64.5K' },
        { label: 'Paid Follows', value: '45.0' },
        { label: 'Total Engagement', value: '7.3K' },
        { label: 'Results (Conversions)', value: '2,434', isHighlight: true },
        { label: 'Amount Spent', value: '฿12,250.77' }
      ],
      ageBreakdown: [
        { label: 'AGE_25_34 (25 - 34 years)', count: '102,152', percentage: '51.2%', color: '#2563EB', flex: 51.2 },
        { label: 'AGE_35_44 (35 - 44 years)', count: '38,675', percentage: '22.4%', color: '#8B5CF6', flex: 22.4 },
        { label: 'AGE_55_100 (55+ years)', count: '28,826', percentage: '13.1%', color: '#EC4899', flex: 13.1 },
        { label: 'AGE_45_54 (45 - 54 years)', count: '19,339', percentage: '12.2%', color: '#F59E0B', flex: 12.2 }
      ],
      locationBreakdown: [
        { province: 'Chonburi Province', percentage: '48.9%', color: '#EC4899' },
        { province: 'Rayong Province', percentage: '8.9%', color: '#8B5CF6' },
        { province: 'Nonthaburi Province', percentage: '6.7%', color: '#2563EB' },
        { province: 'Ayutthaya Province', percentage: '6.7%', color: '#F59E0B' },
        { province: 'Other Provinces', percentage: '28.8%', color: '#10B981' }
      ],
      abTesting: [
        { group: 'welding+powertools+manufacture', views: '160,817', sixSecViews: '8,198', impressions: '162,569', reach: '54,374', follows: '18' },
        { group: 'Welding General Target', views: '29,603', sixSecViews: '6,027', impressions: '29,566', reach: '12,365', follows: '27' }
      ],
      keywords: [
        { name: 'MIG160S Plus+ (MIG160S Plus+)', clicks: '54,274', impressions: '162,569', ctr: '5.04%', avgCpc: '฿2.51', conv: '2,427', cpl: '฿2.51', convRate: '4.47%', cost: '฿6,098.75' },
        { name: 'Premium Vertical Needle KV26 (Sales)', clicks: '7,376', impressions: '14,917', ctr: '20.18%', avgCpc: '฿750.96', conv: '4', cpl: '฿750.96', convRate: '0.05%', cost: '฿3,003.85' },
        { name: 'MIG160S Plus+ (Sales - Welding)', clicks: '6,949', impressions: '12,710', ctr: '20.65%', avgCpc: '฿1,405.07', conv: '2', cpl: '฿1,405.07', convRate: '0.03%', cost: '฿2,810.19' },
        { name: 'Welding Wire KV26 (Sales)', clicks: '1,446', impressions: '1,502', ctr: '19.31%', avgCpc: '฿219.94', conv: '1', cpl: '฿219.94', convRate: '0.07%', cost: '฿219.94' },
        { name: 'TIG Welding Technique (Sales)', clicks: '88', impressions: '90', ctr: '28.89%', avgCpc: '฿3.82', conv: '0', cpl: '฿0.00', convRate: '0.00%', cost: '฿3.82' },
        { name: 'Field Welding Cutting Kit (Sales)', clicks: '138', impressions: '142', ctr: '36.62%', avgCpc: '฿3.93', conv: '0', cpl: '฿0.00', convRate: '0.00%', cost: '฿3.93' },
        { name: 'MMA110 Mini Welder (Sales)', clicks: '202', impressions: '205', ctr: '11.71%', avgCpc: '฿14.46', conv: '0', cpl: '฿0.00', convRate: '0.00%', cost: '฿14.46' }
      ]
    },
    rpm_meta: {
      title: 'Meta Ads Overall Performance Report',
      kpis: [
        { label: 'Impressions', value: '519.4K' },
        { label: 'Reach', value: '121.0K' },
        { label: 'New Messaging', value: '266.0', isHighlight: true },
        { label: 'Cost / Messaging', value: '฿91.90' },
        { label: 'Leads (all)', value: '58.0' },
        { label: 'Amount Spent', value: '฿21,638.27' }
      ],
      genderBreakdown: [
        { label: 'Male', percentage: '68.4%', flex: 68.4, color: '#2563EB' },
        { label: 'Female', percentage: '31.6%', flex: 31.6, color: '#EC4899' }
      ],
      platformBreakdown: [
        { label: 'Mobile App (iOS & Android)', percentage: '84.5%', flex: 84.5, color: '#2563EB' },
        { label: 'Desktop Browser', percentage: '15.5%', flex: 15.5, color: '#8B5CF6' }
      ],
      ageBreakdown: [
        { label: '25 - 34 years', percentage: '48.2%', flex: 48.2, color: '#2563EB' },
        { label: '35 - 44 years', percentage: '28.4%', flex: 28.4, color: '#8B5CF6' },
        { label: '45 - 54 years', percentage: '15.1%', flex: 15.1, color: '#F59E0B' },
        { label: '55+ years', percentage: '8.3%', flex: 8.3, color: '#10B981' }
      ],
      postInsights: [
        { name: 'MIG160S Welder Showcase', campaign: 'Inverter - Welding Machine', engagements: '160,521', reactions: '1,488', shares: '27', comments: '5' },
        { name: 'Plasma Cutter SELECTCUT30/40', campaign: 'Lead Campaign - SELECTCUT30/40', engagements: '11,264', reactions: '325', shares: '18', comments: '15' },
        { name: 'Laser Welder Speed Demo', campaign: 'Lead Campaign - Laser', engagements: '10,917', reactions: '285', shares: '8', comments: '22' },
        { name: '210mini Inverter Machine', campaign: 'Engagement - 210mini', engagements: '10,070', reactions: '380', shares: '12', comments: '10' }
      ],
      keywords: [
        { name: 'Lead Campaign - Laser (Laser Welding)', clicks: '1,381', impressions: '31,517', ctr: '4.38%', avgCpc: '฿127.16', conv: '36.00', cpl: '฿455.64', convRate: '2.61%', cost: '฿4,577.60' },
        { name: 'Lead Campaign - SELECTCUT30/40', clicks: '1,733', impressions: '42,637', ctr: '4.06%', avgCpc: '฿116.53', conv: '35.00', cpl: '฿147.00', convRate: '2.02%', cost: '฿4,078.48' },
        { name: 'Inverter - Welding Machine', clicks: '2,052', impressions: '34,970', ctr: '5.87%', avgCpc: '฿32.29', conv: '113.00', cpl: '฿1,019.04', convRate: '5.51%', cost: '฿3,648.71' },
        { name: 'Engagement Campaign (Video Demonstration)', clicks: '3,431', impressions: '209,045', ctr: '1.64%', avgCpc: '฿580.67', conv: '5.00', cpl: '฿0.00', convRate: '0.15%', cost: '฿2,903.37' },
        { name: 'Engagement Campaign - WELDING User', clicks: '1,583', impressions: '36,423', ctr: '4.35%', avgCpc: '฿59.10', conv: '38.00', cpl: '฿561.44', convRate: '2.40%', cost: '฿2,245.77' },
        { name: 'Engagement - 210mini (Inverter Mini)', clicks: '7,973', impressions: '133,733', ctr: '5.96%', avgCpc: '฿54.66', conv: '33.00', cpl: '฿1,803.73', convRate: '0.41%', cost: '฿1,803.73' }
      ]
    },
    rpm_jll_fb: {
      title: 'Facebook Ads Lead Generation Performance',
      kpis: [
        { label: 'Impressions', value: '253,700' },
        { label: 'Reach', value: '54,300' },
        { label: 'Frequency', value: '4.67' },
        { label: 'Avg. CPL', value: '฿670.94' },
        { label: 'Total Leads', value: '119', isHighlight: true },
        { label: 'Qualified Leads', value: '81' },
        { label: 'Total Cost', value: '฿79,842.00' },
        { label: 'Qualify Rate', value: '68.07%' }
      ],
      keywords: [
        { name: 'Lead Form — Luxury Condominium Residence Ad', clicks: '8,601', impressions: '25,788', ctr: '12.8%', avgCpc: '฿40.11', conv: '55.00', cpl: '฿423.74', convRate: '69.1%', cost: '฿23,305.78' },
        { name: 'Lead Form — Exclusive Penthouse Suite Ad', clicks: '5,257', impressions: '14,316', ctr: '10.5%', avgCpc: '฿50.51', conv: '20.00', cpl: '฿659.59', convRate: '70.0%', cost: '฿13,191.79' },
        { name: 'Lead Form — Sea View Residence Inquiry Ad', clicks: '13,329', impressions: '71,070', ctr: '8.4%', avgCpc: '฿14.91', conv: '19.00', cpl: '฿605.14', convRate: '63.2%', cost: '฿11,497.66' },
        { name: 'Lead Form — Premium Real Estate Investment Ad', clicks: '6,986', impressions: '22,987', ctr: '9.2%', avgCpc: '฿27.47', conv: '19.00', cpl: '฿889.15', convRate: '57.9%', cost: '฿16,893.82' },
        { name: 'Lead Form — High-Rise Luxury Unit Promo Ad', clicks: '6,448', impressions: '16,332', ctr: '7.8%', avgCpc: '฿46.14', conv: '12.00', cpl: '฿1,245.66', convRate: '66.7%', cost: '฿14,947.95' }
      ]
    }
  };

  const currentReportObj = monthlyReports[mainReport] || monthlyReports.rpm_gg;
  const currentActiveData = allReportData[mainReport] || allReportData.rpm_gg;

  const currentSubTabObj = currentActiveData.subData ? (currentActiveData.subData[subTab] || currentActiveData.subData.overview) : null;
  const activeKpis = currentSubTabObj ? currentSubTabObj.kpis : currentActiveData.kpis;
  const activeKeywords = currentSubTabObj ? currentSubTabObj.keywords : currentActiveData.keywords;
  const conversionsBreakdown = currentSubTabObj?.conversionsBreakdown;
  const regionsBreakdown = currentSubTabObj?.regionsBreakdown;

  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => setIsRefreshing(false), 500);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#09090B' }}>Marketing Analytics Hub</h2>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button
            type="button"
            onClick={handleRefresh}
            style={{
              height: '34px',
              padding: '0 12px',
              borderRadius: '6px',
              border: '1px solid #D4D4D8',
              backgroundColor: '#FFFFFF',
              color: '#09090B',
              fontSize: '12.5px',
              fontWeight: 500,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <RefreshCw size={13} className={isRefreshing ? 'spin' : ''} />
            <span>Sync</span>
          </button>
        </div>
      </div>

      {/* Main Report Selection Pills */}
      <div style={{ display: 'flex', gap: '6px', overflowX: 'auto', paddingBottom: '4px' }}>
        {Object.keys(monthlyReports).map((key) => {
          const item = monthlyReports[key];
          return (
            <button
              key={key}
              onClick={() => {
                setMainReport(key);
                if (key === 'rpm_gg') setSubTab('overview');
              }}
              style={{
                padding: '6px 14px',
                borderRadius: '6px',
                border: mainReport === key ? '1px solid #10B981' : '1px solid #E4E4E7',
                backgroundColor: mainReport === key ? '#ECFDF5' : '#FFFFFF',
                color: mainReport === key ? '#047857' : '#52525B',
                fontSize: '12.5px',
                fontWeight: mainReport === key ? 700 : 500,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              {item.name}
            </button>
          );
        })}
      </div>

      {/* Title */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: '14px', fontWeight: 700, color: '#09090B' }}>
          {currentSubTabObj?.title || currentReportObj.title}
        </div>
      </div>

      {/* Native High Performance Analytics Summary */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Sub-Tabs for Google Ads */}
        {mainReport === 'rpm_gg' && allReportData.rpm_gg.tabs && (
          <div style={{ display: 'flex', gap: '6px', borderBottom: '1px solid #E4E4E7', paddingBottom: '8px', overflowX: 'auto' }}>
            {allReportData.rpm_gg.tabs.map((t) => (
              <button
                key={t.id}
                onClick={() => setSubTab(t.id)}
                style={{
                  padding: '5px 12px',
                  borderRadius: '4px',
                  border: 'none',
                  backgroundColor: subTab === t.id ? '#10B981' : '#F4F4F5',
                  color: subTab === t.id ? '#FFFFFF' : '#52525B',
                  fontSize: '12px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}
              >
                {t.label}
              </button>
            ))}
          </div>
        )}

        {/* Metric Cards Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '12px' }}>
          {activeKpis?.map((kpi, idx) => (
            <div
              key={idx}
              className="card"
              style={{
                padding: '14px 16px',
                backgroundColor: kpi.isHighlight ? '#ECFDF5' : '#FFFFFF',
                borderColor: kpi.isHighlight ? '#A7F3D0' : '#E4E4E7'
              }}
            >
              <div style={{ fontSize: '12px', color: kpi.isHighlight ? '#047857' : '#71717A', fontWeight: 500 }}>{kpi.label}</div>
              <div style={{ fontSize: '22px', fontWeight: 700, color: kpi.isHighlight ? '#065F46' : '#09090B', marginTop: '4px' }}>
                {kpi.value}
              </div>
            </div>
          ))}
        </div>

        {/* Conversions Segment Breakdown (If available) */}
        {conversionsBreakdown && conversionsBreakdown.length > 0 && (
          <div className="card" style={{ padding: '16px 20px', backgroundColor: '#FAFAFC' }}>
            <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>Search Conversions Breakdown</span>
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px' }}>
              {conversionsBreakdown.map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div key={idx} style={{ padding: '10px 14px', backgroundColor: '#FFFFFF', border: '1px solid #E4E4E7', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Icon size={16} color={item.color} />
                      <span style={{ fontSize: '12.5px', fontWeight: 600, color: '#374151' }}>{item.type}</span>
                    </div>
                    <span style={{ fontSize: '15px', fontWeight: 800, color: '#09090B', fontFamily: 'var(--font-mono)' }}>{item.count}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* TikTok Ads Visual Demographics & Location Charts */}
        {mainReport === 'rpm_tt' && (
          <div className="grid-2">
            {/* Results by Age Chart */}
            <div className="card" style={{ padding: '16px 20px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <PieIcon size={15} color="#2563EB" />
                <span>Results by Age Group</span>
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {currentActiveData.ageBreakdown.map((age, idx) => (
                  <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{age.label}</span>
                      <span style={{ fontWeight: 700, color: '#09090B' }}>{age.percentage} ({age.count} impr)</span>
                    </div>
                    <div style={{ height: '8px', backgroundColor: '#F3F4F6', borderRadius: '9999px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: age.percentage, backgroundColor: age.color, borderRadius: '9999px', transition: 'width 0.5s ease' }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Paid Follows by Location Chart */}
            <div className="card" style={{ padding: '16px 20px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <MapPin size={15} color="#EC4899" />
                <span>Paid Follows by Location</span>
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {currentActiveData.locationBreakdown.map((loc, idx) => (
                  <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{loc.province}</span>
                      <span style={{ fontWeight: 700, color: '#09090B' }}>{loc.percentage}</span>
                    </div>
                    <div style={{ height: '8px', backgroundColor: '#F3F4F6', borderRadius: '9999px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: loc.percentage, backgroundColor: loc.color, borderRadius: '9999px', transition: 'width 0.5s ease' }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* TikTok AB Testing Audience Table */}
        {mainReport === 'rpm_tt' && currentActiveData.abTesting && (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #E4E4E7' }}>
              <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#09090B' }}>AB Testing Target Audience</h4>
            </div>
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Ad Group Target Audience</th>
                    <th>Video Views</th>
                    <th>6-sec Video Views</th>
                    <th>Impressions</th>
                    <th>Reach</th>
                    <th>Paid Follows</th>
                  </tr>
                </thead>
                <tbody>
                  {currentActiveData.abTesting.map((ab, idx) => (
                    <tr key={idx}>
                      <td style={{ color: '#71717A', fontSize: '12px' }}>{idx + 1}</td>
                      <td style={{ fontWeight: 600, color: '#09090B' }}>{ab.group}</td>
                      <td style={{ fontWeight: 600, color: '#2563EB' }}>{ab.views}</td>
                      <td>{ab.sixSecViews}</td>
                      <td>{ab.impressions}</td>
                      <td>{ab.reach}</td>
                      <td style={{ fontWeight: 700, color: '#059669' }}>{ab.follows}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Meta Ads Demographic & Device Platform Charts */}
        {mainReport === 'rpm_meta' && (
          <div className="grid-3">
            {/* Device Platform */}
            <div className="card" style={{ padding: '16px 20px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Smartphone size={15} color="#2563EB" />
                <span>Device Platform</span>
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {currentActiveData.platformBreakdown.map((dev, idx) => (
                  <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{dev.label}</span>
                      <span style={{ fontWeight: 700, color: '#09090B' }}>{dev.percentage}</span>
                    </div>
                    <div style={{ height: '8px', backgroundColor: '#F3F4F6', borderRadius: '9999px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: dev.percentage, backgroundColor: dev.color, borderRadius: '9999px' }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Gender Reach */}
            <div className="card" style={{ padding: '16px 20px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Users size={15} color="#EC4899" />
                <span>Reach by Gender</span>
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {currentActiveData.genderBreakdown.map((gen, idx) => (
                  <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{gen.label}</span>
                      <span style={{ fontWeight: 700, color: '#09090B' }}>{gen.percentage}</span>
                    </div>
                    <div style={{ height: '8px', backgroundColor: '#F3F4F6', borderRadius: '9999px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: gen.percentage, backgroundColor: gen.color, borderRadius: '9999px' }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Reach by Age */}
            <div className="card" style={{ padding: '16px 20px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <PieIcon size={15} color="#8B5CF6" />
                <span>Reach by Age</span>
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {currentActiveData.ageBreakdown.map((age, idx) => (
                  <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{age.label}</span>
                      <span style={{ fontWeight: 700, color: '#09090B' }}>{age.percentage}</span>
                    </div>
                    <div style={{ height: '8px', backgroundColor: '#F3F4F6', borderRadius: '9999px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: age.percentage, backgroundColor: age.color, borderRadius: '9999px' }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Meta Ads Post Insights Matrix */}
        {mainReport === 'rpm_meta' && currentActiveData.postInsights && (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #E4E4E7' }}>
              <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#09090B', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <ThumbsUp size={15} color="#2563EB" />
                <span>Post Insights & Content Engagement</span>
              </h4>
            </div>
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Ad Content / Post Name</th>
                    <th>Campaign Name</th>
                    <th>Post Engagements</th>
                    <th>Reactions</th>
                    <th>Shares</th>
                    <th>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {currentActiveData.postInsights.map((post, idx) => (
                    <tr key={idx}>
                      <td style={{ color: '#71717A', fontSize: '12px' }}>{idx + 1}</td>
                      <td style={{ fontWeight: 600, color: '#09090B' }}>{post.name}</td>
                      <td style={{ color: '#52525B' }}>{post.campaign}</td>
                      <td style={{ fontWeight: 700, color: '#2563EB', backgroundColor: '#EFF6FF' }}>{post.engagements}</td>
                      <td style={{ color: '#059669', fontWeight: 600 }}>{post.reactions}</td>
                      <td style={{ fontWeight: 500 }}>{post.shares}</td>
                      <td style={{ fontWeight: 500 }}>{post.comments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Region Breakdown Table for P-Max */}
        {regionsBreakdown && (
          <div className="card" style={{ padding: '16px 20px' }}>
            <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#09090B', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <MapPin size={14} color="#2563EB" />
              <span>Region Breakdown (Clicks & Conversions)</span>
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {regionsBreakdown.map((reg, idx) => (
                <div key={idx} style={{ padding: '8px 12px', borderBottom: '1px solid #F4F4F5', display: 'flex', justifyContent: 'space-between', fontSize: '12.5px' }}>
                  <span style={{ fontWeight: 500, color: '#374151' }}>{reg.region}</span>
                  <span style={{ fontWeight: 700, color: '#09090B' }}>{reg.clicks} clicks / {reg.conversions} conv.</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Table */}
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #E4E4E7', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 className="card-title" style={{ fontSize: '15px' }}>Campaign Analytics Matrix</h3>
            <div style={{ position: 'relative' }}>
              <Search size={14} color="#71717A" style={{ position: 'absolute', left: '10px', top: '11px' }} />
              <input
                type="text"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                placeholder="Search analytics..."
                style={{ paddingLeft: '32px', height: '34px', fontSize: '12.5px', width: '220px' }}
              />
            </div>
          </div>

          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Campaign / Keyword Name</th>
                  <th>Clicks / Reach</th>
                  <th>Impressions</th>
                  <th>CTR</th>
                  <th>Avg. CPC / CPL</th>
                  <th>Conversions / Leads</th>
                  <th>Cost (฿)</th>
                  <th>Cost / Conv.</th>
                  <th>Conv. Rate</th>
                </tr>
              </thead>
              <tbody>
                {(activeKeywords || [])
                  .filter(k => k.name.toLowerCase().includes(searchKeyword.toLowerCase()))
                  .map((kw, idx) => (
                    <tr key={idx}>
                      <td style={{ color: '#71717A', fontSize: '12px' }}>{idx + 1}</td>
                      <td style={{ fontWeight: 600, color: '#09090B' }}>{kw.name}</td>
                      <td style={{ fontWeight: 500, color: '#09090B' }}>{kw.clicks}</td>
                      <td style={{ color: '#71717A' }}>{kw.impressions}</td>
                      <td>{kw.ctr}</td>
                      <td style={{ fontFamily: 'var(--font-mono)' }}>{kw.avgCpc}</td>
                      <td style={{ fontWeight: 700, color: '#059669', backgroundColor: '#F0FDFA' }}>{kw.conv}</td>
                      <td style={{ fontFamily: 'var(--font-mono)' }}>{kw.cost}</td>
                      <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: '#059669' }}>{kw.cpl}</td>
                      <td style={{ fontWeight: 600 }}>{kw.convRate}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
